export const vouchersSelector = state => state.vouchers.get('vouchers');
export const voucherOffsetSelector = state => state.vouchers.get('offset');
export const vouchersLoadingSelector = state => state.vouchers.get('isLoading');
export const hasMoreSelector = state => state.vouchers.get('hasMore');
